// src/env-dump.ts
// Nur Ausgabe der Env-Werte, die Vite ins Frontend injiziert hat.

const all = import.meta.env;

// 1) Komplettes Objekt (inkl. MODE, BASE_URL, DEV/PROD)
console.groupCollapsed("[ENV] import.meta.env (roh)");
console.log(all);
console.groupEnd();

// 2) Nur eure VITE_-Variablen als Tabelle
const viteEntries = Object.entries(all).filter(([k]) => k.startsWith("VITE_"));
console.groupCollapsed("[ENV] VITE_* Variablen (Tabelle)");
console.table(
  viteEntries.map(([key, value]) => ({
    key,
    value: String(value),
  })),
);
console.groupEnd();

// 3) Nur die Keys (falls du nur sehen willst, ob sie existieren)
console.groupCollapsed("[ENV] VITE_* Keys (nur Namen)");
console.log(viteEntries.map(([k]) => k));
console.groupEnd();

export {};
